// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"social-media-item-module--menuItem--1RtZg","menuLink":"social-media-item-module--menuLink--1-VVb","socialIcon":"social-media-item-module--socialIcon--3_idG"};